'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React, { useEffect, useState } from 'react'
import { useFormikContext, Field } from 'formik'

// walrus
import Text from '@components/kit/text'
import Box from '@components/kit/box'
import Button from '@components/kit/button'
import Form from '@components/kit/form'
import { ToggleArrowIcon } from '@components/kit/icons'

// lib
import { FollowUpDashboardFormValues } from './member-follow-up-dashboard.web'

/* -----------------------------------------------------------------------------
 * ReportsSortButton
 * -------------------------------------------------------------------------- */

type ReportsSortButtonProps = {
  label: string
  ascOption: string
  descOption: string
}

export const ReportsSortButton = ({
  label,
  ascOption,
  descOption
}: ReportsSortButtonProps) => {
  const { values, setFieldValue, handleSubmit } =
    useFormikContext<FollowUpDashboardFormValues>()
  const { order_by }: FollowUpDashboardFormValues = values
  const iconActive = order_by === ascOption || order_by === descOption
  const iconState = order_by.includes('DESC') ? 'down' : 'up'

  const handleClick = () => {
    setFieldValue('order_by', order_by === descOption ? ascOption : descOption)
    handleSubmit()
  }

  return (
    <Box>
      <Button
        shape='rectangular'
        size='small'
        variant='gray'
        justifyContent='space-between'
        backgroundColor='transparent'
        p='00'
        onPress={handleClick}
      >
        <Text fontSize={12} textColor='purple' fontWeight='bold'>
          {label}
        </Text>

        <ToggleArrowIcon
          fill={iconActive ? 'purple' : 'shade04'}
          state={iconState}
          ml='12'
        />

        <Form>
          <Field type='hidden' name='order_by' />
        </Form>
      </Button>
    </Box>
  )
}
